// import { Component } from "react";

// export default class App extends Component {
//   state = {
//     contacts: [
//     {id: 'id-1', name: 'Rosie Simpson', number: '459-12-56'},
//     {id: 'id-2', name: 'Hermione Kline', number: '443-89-12'},
//     {id: 'id-3', name: 'Eden Clements', number: '645-17-79'},
//     {id: 'id-4', name: 'Annie Copeland', number: '227-91-26'},
//   ],
//     filter: "",
//     name: "",
//     number: "",
//   };

//   componentDidMount() {
//     const savedContacts = localStorage.getItem("contacts");
//     if (savedContacts) {
//       this.setState({ contacts: JSON.parse(savedContacts) });
//     }
//   }

//   componentDidUpdate(prevState) {
//     if (prevState.contacts !== this.state.contacts) {
//       localStorage.setItem(
//         "contacts",
//         JSON.stringify(this.state.contacts)
//       );
//     }
//   }

//   handleChange = e => {
//     const { name, value } = e.target;
//     this.setState({ [name]: value });
//   };

//   handleSubmit = e => {
//     e.preventDefault();

//     const { name, number, contacts } = this.state;

//     const isExist = contacts.find(
//       contact => contact.name.toLowerCase() === name.toLowerCase()
//     );

//     const newContact = {
//       id: Date.now() + 1,
//       name,
//       number,
//     };

//     this.setState(prevState => ({
//       contacts: [...prevState.contacts, newContact],
//       name: "",
//       number: "",
//     }));
//   };

//   deleteContact = id => {
//     this.setState(prevState => ({
//       contacts: prevState.contacts.filter(
//         contact => contact.id !== id
//       ),
//     }));
//   };

//   render() {
//     const { name, number, filter, contacts } = this.state;

//     const filteredContacts = contacts.filter(contact =>
//       contact.name.toLowerCase().includes(filter.toLowerCase())
//     );

//     return (
//       <div>
//         <h1>Телефонна книга</h1>

//         <form onSubmit={this.handleSubmit}>
//           <input
//             type="text"
//             name="name"
//             value={name}
//             onChange={this.handleChange}
//             placeholder="Name"
//             required
//           />
//           <input
//             type="text"
//             name="number"
//             value={number}
//             onChange={this.handleChange}
//             placeholder="Number"
//             required
//           />
//           <button type="submit">додати контакт</button>
//         </form>

//         <h2>контакит</h2>
//         <input
//           type="text"
//           value={filter}
//           onChange={e => this.setState({ filter: e.target.value })}
//           placeholder="знайти контакт за іменем"
//         />

//         <ul>
//           {filteredContacts.map(({ id, name, number }) => (
//             <li key={id}>
//               Ім'я: {name}, Номер Телефону: {number}
//               <button onClick={() => this.deleteContact(id)}>
//                 видалити
//               </button>
//             </li>
//           ))}
//         </ul>
//       </div>
//     );
//   }
// }

// перероблений код з старого використовуючи хуки та nanoid
import { useState, useEffect } from "react";
import { nanoid } from "nanoid";

export default function Phonebook() {
  const [contacts, setContacts] = useState([
    { id: "id-1", name: "Rosie Simpson", number: "459-12-56" },
    { id: "id-2", name: "Hermione Kline", number: "443-89-12" },
    { id: "id-3", name: "Eden Clements", number: "645-17-79" },
    { id: "id-4", name: "Annie Copeland", number: "227-91-26" },
  ]);

  const [name, setName] = useState("");
  const [number, setNumber] = useState("");
  const [filter, setFilter] = useState("");

  useEffect(() => {
    const savedContacts = localStorage.getItem("contacts");
    if (savedContacts) {
      setContacts(JSON.parse(savedContacts));
    }
  }, []);

  useEffect(() => {
    localStorage.setItem("contacts", JSON.stringify(contacts));
  }, [contacts]);

  const handleSubmit = e => {
    e.preventDefault();
    setContacts(prev => [
      ...prev,
      {
        id: nanoid(),
        name,
        number,
      },
    ]);
    setName("");
    setNumber("");
  };

  const deleteContact = id => {
    setContacts(prev =>
      prev.filter(contact => contact.id !== id)
    );
  };

  const filteredContacts = contacts.filter(contact =>
    contact.name.toLowerCase().includes(filter.toLowerCase())
  );

  return (
    <div>
      <h1 className="title">Phonebook</h1>
      <form className="form-1" onSubmit={handleSubmit}>
        <input className="input-1"
          type="text"
          name="name"
          value={name}
          onChange={e => setName(e.target.value)}
          placeholder="Username"
          required
        />
        <input className="input-2"
          type="tel"
          name="number"
          value={number}
          onChange={e => setNumber(e.target.value)}
          placeholder="Phone Number"
          required
        />
        <button className="button" type="submit">Add contact</button>
      </form>
      <h2 className="contacts">Contacts</h2>
      <input className="input-3"
        type="text"
        value={filter}
        onChange={e => setFilter(e.target.value)}
        placeholder="Find Users"
      />
      <ul className="list">
        {filteredContacts.map(({ id, name, number }) => (
          <li className="item" key={id}>
            <p className="username">{name} : {number}</p>
            <button className="button-2" onClick={() => deleteContact(id)}>
              Delete
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
}
